import { AppManager } from "..";
import { IOEventTypes } from "../RealtimeManager";

export class OrgNetworkHelper {
    static networkDataReceived = <K extends keyof IOEventTypes>(evt: K, resp: any): void => {
        switch (evt) {
        }
    };

    static onConnectionRestoredSync(currentRoute: string, currentPathName: string) {
        switch (currentRoute) {
        }
    }
}
